export enum ModulesEnum {
  CUSTOMERS = 'customers',
  SUPPLIERS = 'suppliers',
  VEHICLES = 'vehicles',
  VEHICLE_GROUPS = 'vehicle-groups',
  VEHICLE_CATEGORIES = 'vehicle-categories',
  VEHICLE_COLORS = 'vehicle-colors',
  VEHICLE_MAKES = 'vehicle-makes',
  VEHICLE_MODELS = 'vehicle-models',
  LOCATIONS = 'locations',
  AGENTS = 'agents',
  AGENT_CATEGORIES = 'agent-categories',
  TAGS = 'tags',
  RENTER_ACCOUNTS = 'renter-accounts',
  RENTALS = 'rentals',
  MAINTENANCES = 'maintenances',
  RESERVATIONS = 'reservations',
  ROAD_TAXES = 'road-taxes',
  ROAD_WORTHY_CHECKS = 'road-worthy-checks',
  DAMAGES = 'damages',
  INSURANCES = 'insurances',
  TRANSACTIONS = 'transactions',
}
